import { EMPLOYEE_WORKING_HOURS_TOGGLE } from 'reduxStore/actionsConst';
import { createAction } from 'reduxStore/actionCreator';

export const setEmployeeWorkingHoursToggle = (isChecked: boolean) =>
  createAction(EMPLOYEE_WORKING_HOURS_TOGGLE, { isChecked });
